module.exports = __webpack_public_path__ + "static/media/shield.06d3514e.svg";